<footer class="footer">
    <div class="bwr-footer">
        <p>@2021 Bristol West. All rights reserved</p>
    </div>
</footer>

